import React from 'react';
import { resolveImage } from '../../utils/api';

const t = (field, lang = 'en') => {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return field[lang] || field.en || '';
};

export default function About({ content, scrollTo, lang = 'en' }) {
  const imageUrl = content?.aboutImageUrl ? resolveImage(content.aboutImageUrl) : "https://images.pexels.com/photos/7447310/pexels-photo-7447310.jpeg?auto=compress&cs=tinysrgb&w=900";
  const badgeBig = content?.aboutBadgeBig || "10+";
  const badgeSmallParts = (t(content?.aboutBadgeSmall, lang) || t({ en: 'Years\nof dance', zh: '舞蹈\n年限' }, lang)).split('\n');
  const overline     = t(content?.aboutOverline,     lang) || t({ en: 'About ETS Academy', zh: '關於 ETS 舞蹈學院' }, lang);
  const titleRegular = t(content?.aboutTitleRegular, lang) || t({ en: 'A Platform Built ', zh: '專為 ' }, lang);
  const titleGold    = t(content?.aboutTitleGold,    lang) || t({ en: 'For Dancers', zh: '舞者打造的平台' }, lang);
  const subtext      = t(content?.aboutSubtext,      lang) || t({ en: 'Every Talent Shines Academy is the complete dance management platform.', zh: 'Every Talent Shines 是最完善的舞蹈學院管理平台。' }, lang);
  
  const defaultFeatures = [
    { emoji: '📊', title: t({ en: 'Attendance Tracking', zh: '出勤記錄' }, lang), desc: t({ en: 'Real-time Present / Absent / Late marking with monthly percentage graphs.', zh: '即時出席/缺席/遲到記錄，附有每月百分比圖表。' }, lang) },
    { emoji: '🎯', title: t({ en: 'Personal Objectives', zh: '個人目標' }, lang), desc: t({ en: 'Set skill goals and watch progress bars move from 0 to 100% session by session.', zh: '設定技巧目標，並見證進度條逐節課從 0 到 100% 成長。' }, lang) },
    { emoji: '⭐', title: t({ en: 'Achievement Badges', zh: '成就徽章' }, lang), desc: t({ en: 'Earn Star Performer, Perfect Attendance, and 8 more milestone badges.', zh: '獲得明星學員、全勤獎及其他 8 個里程碑徽章。' }, lang) },
    { emoji: '📝', title: t({ en: 'Tutor Notes', zh: '導師筆記' }, lang), desc: t({ en: 'Personalised, dated feedback from your tutor after every class.', zh: '每堂課後，導師為您提供個人化及有日期的意見反饋。' }, lang) }
  ];

  const features = (content?.aboutFeatures && content.aboutFeatures.length > 0) ? content.aboutFeatures : defaultFeatures;

  return (
    <section className="lp-sec" id="about">
      <div className="lp-container">
        <div className="lp-about-grid">
          <div className="lp-about-img-wrap reveal-l">
            <img src={imageUrl} alt="About Us" className="lp-about-img" style={{filter:'grayscale(15%)'}}/>
            <div className="lp-about-badge">
              <span className="big">{badgeBig}</span>
              <span className="small">{badgeSmallParts[0]}<br/>{badgeSmallParts[1] || ''}</span>
            </div>
          </div>
          <div className="reveal-r">
            <div className="lp-overline">{overline}</div>
            <h2 className="lp-sec-title">{titleRegular} <em className="lp-text-gold">{titleGold}</em></h2>
            <p className="lp-sec-sub">{subtext}</p>
            <div className="lp-about-feats">
              {features.map((f, idx) => (
                <div key={idx} className="lp-about-feat">
                  <span className="lp-about-feat-icon">{f.emoji}</span>
                  <div><div className="lp-about-feat-title">{t(f.title, lang)}</div><div className="lp-about-feat-desc">{t(f.desc, lang)}</div></div>
                </div>
              ))}
            </div>
            <div style={{marginTop:36}}><button className="btn btn-primary btn-lg" onClick={()=>scrollTo('pricing')}>{t({ en: 'Get Started Today →', zh: '立即開始 →' }, lang)}</button></div>
          </div>
        </div>
      </div>
    </section>
  );
}
